export enum ApplicationsCourseStatus {
  declined = 'declined',
  waiting = 'waiting',
  accepted = 'accepted',
  excluded = 'excluded',
  suspended = 'suspended',
}
export const getStatusName = (status: ApplicationsCourseStatus): string =>
  ({
    [ApplicationsCourseStatus.accepted]: 'Одобрена',
    [ApplicationsCourseStatus.declined]: 'Отклонена',
    [ApplicationsCourseStatus.excluded]: 'Исключена',
    [ApplicationsCourseStatus.suspended]: 'Приостановлена',
    [ApplicationsCourseStatus.waiting]: 'Ожидает',
  }[status] || '-')
